function LoadingDirective($compile) {
  'ngInject';

  const loadingSpinner =
    `<i class="fas fa-circle-notch fa-spin text-red"></i>`;

  return {
    restrict: 'A',
    link: function(scope, element, attrs) {
      let originalContent = element.html();
      element.html(loadingSpinner);
      scope.$watch(attrs.loading, function(val) {
        if(val !== null && typeof val != 'undefined') {
          element.html(originalContent);
          $compile(element.contents())(scope);
        } else {
          element.html(loadingSpinner);
        }
      });
    }
  };
}

export default LoadingDirective;



// WEBPACK FOOTER //
// ./client/app/shared/directives/loading.directive.js